class ApoVideo {
  constructor(el) {
    this.el = el;
    this.overlay = el.querySelector('.apo-video-section__overlay');
    this.btn = el.querySelector('.apo-video-section__overlay-btn');
    this.type = el.dataset.videoType;
    this.isPlaying = false;

    if (!this.btn) return;

    this._onMouseMove = this._handleMouseMove.bind(this);

    this.btn.addEventListener('click', () => this._onBtnClick());
    this.el.addEventListener('mouseenter', () => this._showBtn());
    this.el.addEventListener('mouseleave', () => this._hideBtn());

    if (this.type === 'native') this._initNative();
    else if (this.type === 'youtube') this._initYouTube();
    else if (this.type === 'vimeo') this._initVimeo();
  }

  _showBtn() {
    this.btn.style.opacity = '1';
    this.btn.style.transform = 'translate(-50%, -50%) scale(1)';
  }

  _hideBtn() {
    // Ne cacher que si la vidéo est en cours de lecture
    if (!this.isPlaying) return;
    this.btn.style.opacity = '0';
    this.btn.style.transform = 'translate(-50%, -50%) scale(0.85)';
  }

  _handleMouseMove(e) {
    const rect = this.el.getBoundingClientRect();
    const over =
      e.clientX >= rect.left &&
      e.clientX <= rect.right &&
      e.clientY >= rect.top &&
      e.clientY <= rect.bottom;
    over ? this._showBtn() : this._hideBtn();
  }

  _setPlaying(playing) {
    this.isPlaying = playing;
    this.el.classList.toggle('is-playing', playing);

    // When playing, the overlay must not capture pointer events so the iframe stays interactive
    this.overlay.style.pointerEvents = playing ? 'none' : 'auto';
    // But we still detect hover via document mousemove (since the iframe absorbs events)
    if (playing) {
      document.addEventListener('mousemove', this._onMouseMove);
      this._hideBtn(); // cache au démarrage de la lecture
    } else {
      document.removeEventListener('mousemove', this._onMouseMove);
      this._showBtn(); // réaffiche quand en pause
    }
  }

  _onBtnClick() {
    this.isPlaying ? this._pause() : this._play();
  }

  // --- Native video ---

  _initNative() {
    this.video = this.el.querySelector('video');
    if (!this.video) return;
    this.video.addEventListener('play', () => this._setPlaying(true));
    this.video.addEventListener('pause', () => this._setPlaying(false));
    this.video.addEventListener('ended', () => this._setPlaying(false));
  }

  _play() {
    if (this.type === 'native') this.video?.play();
    else if (this.type === 'youtube') this.ytPlayer?.playVideo();
    else if (this.type === 'vimeo') this.vimeoPlayer?.play();
  }

  _pause() {
    if (this.type === 'native') this.video?.pause();
    else if (this.type === 'youtube') this.ytPlayer?.pauseVideo();
    else if (this.type === 'vimeo') this.vimeoPlayer?.pause();
  }

  // --- YouTube ---

  _initYouTube() {
    const iframe = this.el.querySelector('iframe.js-youtube');
    if (!iframe) return;

    const setup = () => {
      this.ytPlayer = new YT.Player(iframe, {
        events: {
          onStateChange: (e) => {
            this._setPlaying(e.data === YT.PlayerState.PLAYING);
          }
        }
      });
    };

    if (window.YT?.Player) {
      setup();
    } else {
      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        const s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(s);
      }
      const prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        prev?.();
        setup();
      };
    }
  }

  // --- Vimeo ---

  _initVimeo() {
    const iframe = this.el.querySelector('iframe.js-vimeo');
    if (!iframe) return;

    const setup = () => {
      this.vimeoPlayer = new Vimeo.Player(iframe);
      this.vimeoPlayer.on('play', () => this._setPlaying(true));
      this.vimeoPlayer.on('pause', () => this._setPlaying(false));
      this.vimeoPlayer.on('ended', () => this._setPlaying(false));
    };

    if (window.Vimeo?.Player) {
      setup();
    } else {
      if (!document.querySelector('script[src*="player.vimeo.com"]')) {
        const s = document.createElement('script');
        s.src = 'https://player.vimeo.com/api/player.js';
        s.onload = setup;
        document.head.appendChild(s);
      }
    }
  }
}

document
  .querySelectorAll('.apo-video-section__embed-wrapper[data-video-type]')
  .forEach((el) => new ApoVideo(el));
